import styled from "styled-components";
import bgDesk from '../../Assets/bg_desk.png'
import bgSctors from '../../Assets/bg_ectors.png'

export const Content = styled.div`
  position: relative;
  overflow-x: hidden;

   @media (min-width: 1440px) {
    background-size: 1440px;
   }
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 16px;
  display: flex;
  gap: 16px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-width: 1440px; 
  width: 100%;
  padding: 40px 16px;
  margin: 0 auto;
  margin-top: -1px;
  overflow-x: visible;

  @media (min-width: 1000px) {
    flex-direction: row;
    gap: 40px;
   }

   @media (min-width:  1200px) {
    padding: 40px 120px;
   }
`

export const TextBox = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 24px;
 
  @media (min-width:  768px) {
    justify-content: space-between;
   
  }

  @media (min-width: 1000px) {
    width:368px !important;
    max-width: 368px;
    flex-shrink: 0;
    margin-top: 0;
  }

   @media (min-width:  1440px) {
    margin-top: 90px;
   }
`

export const Title = styled.h2`
  font-size: 32px;
  font-style: normal;
  font-weight: 550;
  line-height: 40px;
  letter-spacing: 1px;
`

export const Text = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 325;
  line-height: 24px;
  max-width: 860px;
  letter-spacing: 1px;
  display: none;

@media (min-width:  768px) {
  font-size: 18px;
  font-style: normal;
  font-weight: 325;
  line-height: 28px;
  display: block;
}

@media (min-width:  1020px) {
  font-size: 20px;
  font-style: normal;
  font-weight: 325;
  line-height: 28px;
}
`

export const ActionBtn = styled.button`
  background-color: var(--orange-500);
  border: 1px solid var(--orange-500);
`

export const CrouselBtnBox = styled.div`
  display: none;
  align-items: center;
  justify-content: flex-end;
  gap:16px;

  @media (min-width: 1000px) {
   display: flex;
  }
`

export const CrouselBtn = styled.button`
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: var(--orange-700);

  &:hover{
    background-color: var(--orange-400);
    color:  var(--orange-600);
    border:1px solid var(--orange-300);
  }
`

export const CarouselBox = styled.div`
  max-width: 100%;
  flex: 1;

  .swiper {
    width: 100%;
    padding: 16px 0;
  }

  .swiper-slide {
  display: flex;
  justify-content: flex-start;
  width: auto;
}

   @media (min-width:  1440px) {
    margin-top: 90px;
   }
`;

export const Card = styled.div` 
    display: flex;
    padding: 8px 8px 16px 8px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    gap: 24px;
    border-radius: 16px;
    background: var(--white);
    width: 355px;
    color: var(--orange-600);
    text-align: left;
    height: 450px;

    img {
      width: 100%;
      height: 200px;
      object-fit: cover;
      border-radius: 10px;
    }

    h3 {
      font-size: 32px;
      font-style: normal;
      font-weight: 550;
      line-height: 40px; 
      letter-spacing: 1px;
          }

    p {
      font-size: 16px;
      font-style: normal;
      font-weight: 325;
      line-height: 24px; 
      letter-spacing: 1px;
    }

    div{
      display: flex;
      flex-direction: column;
      gap: 24px;
    }


    @media (min-width: 1000px) {
     flex-direction: row;
     height: 307px;
     width: 587px;
     align-items: center;

     img{
      height: 100%;
     }
     
     h3{
     width: 230px;
     }

     p{
     width: 230px;
     }
   }
`;